import { Component, Input } from '@angular/core';

@Component({
    selector: 'spv2-input-error-display',
    templateUrl: './input-error-display.component.html',
    styleUrls: ['./input-error-display.component.scss'],
    standalone: false
})
export class InputErrorDisplayComponent{

  @Input() text: string;
  @Input() show: boolean;
}
